module.exports = __webpack_public_path__ + "static/img/12.9ef11b19.webp";